import "./App.css";
import MagazineNavbar from "./components/Navbar";
import { Routes, Route, useLocation } from "react-router-dom";
// import ProtectedRoute from "./ProtectedRoute";
import "animate.css";
import LoginPage from "./pages/Login";
import Home from "./pages/home";
import Footer from "./components/Footer";
import AboutUs from "./pages/AboutUs";
import ContactUs from "./pages/ContactUs";
import MagazineCategories from "./components/MagazineCategories";
import SubscriptionPage from "./pages/SubscriptionPage";
import CartPage from "./pages/CartPage";
import SignupPage from "./pages/SignupPage";
import ArticleCategories from "./pages/ArticleCategories";
import DailyNews from "./pages/DailyNews";
import MagazinePreview from "./pages/MagazinePreview";
import DailyNewsPreview from "./pages/DailyNewsPreview";
import CheckoutPage from "./pages/CheckoutPage";
import ThankYouPage from "./pages/ThankYouPage";
import Stories from "./pages/stories";
import OrderHistory from "./pages/OrderHistory";
import BookdescriptionPage from "./pages/Bookdescription";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsConditions from "./pages/Termsandconditions";
import VideosPage from "./pages/VideosPage";
import PdfViewerPage from "./pages/PdfViewerPage";
import DailyNewsPdfView from "./pages/DailyNewsPdfView";
import UserProfile from "./pages/UserProfile";

function AppContent() {
  const location = useLocation();
  const hideNavbar =
    location.pathname === "/login" ||
    location.pathname === "/signup" ||
    location.pathname === "/preview" |
    location.pathname === "/news_preview"; // hide navbar on login
  const hideFooter =
    location.pathname === "/login" ||
    location.pathname === "/signup" ||
    location.pathname === "/preview" ||
    location.pathname === "/news_preview"; // hide footer on login

  return (
    <div className="App">
      {/* Show Navbar only if not login page */}
      {!hideNavbar && <MagazineNavbar />}

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/contact" element={<ContactUs />} />
        {/* <Route path="/magazines" element={<MagazineCategories />} /> */}
        <Route path="/magazines" element={<MagazineCategories />} />
        <Route path="/magazines/:mp_id/:sp_id" element={<MagazineCategories />} />
        <Route path="/subscription/:productId" element={<SubscriptionPage />} />
        {/* <Route path="/subscription/:magname" element={<SubscriptionPage />} /> */}
        <Route path="/checkout" element={<CheckoutPage />} />
        <Route path="/cart" element={<CartPage />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/orderhistory" element={<OrderHistory />} />
        <Route path="/articles" element={<ArticleCategories />} />
        <Route path="/articles/:mp_id/:sp_id" element={<ArticleCategories />} />
        <Route path="/dailyNews" element={<DailyNews />} />
        <Route path="/preview" element={<MagazinePreview />} />
        <Route path="/news_preview" element={<DailyNewsPreview />} />
        <Route path="/thankyou" element={<ThankYouPage />} />
        <Route path="/stories" element={<Stories />} />
        <Route path="/bookdescription/:productId" element={<BookdescriptionPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-and-conditions" element={<TermsConditions />} />
        <Route path="/videos" element={<VideosPage />} />
        <Route path="/pdf-viewer/:id" element={<PdfViewerPage/>} />
        <Route path="/daily-news-pdf/:id" element={<DailyNewsPdfView/>} />
        <Route path="/profile" element={<UserProfile/>} />
        {/* Add more routes here */}
      </Routes>

      {/* Show Footer only if not login page */}
      {!hideFooter && <Footer />}
    </div>
  );
}

function App() {
  return <AppContent />;
}

export default App;
